<template>
  <div class="pageContent">
    <span  class="function">统计函数：{{centerTitle}}</span>
    <emptyShow v-if="!hasData" ></emptyShow>
    <div v-show="hasData" id="chart1" style="width: 100%;height:90%" ref="myCharts"></div>
  </div>
</template>

<script>
import echarts from 'echarts'
import emptyImg from '@img/empty.png'
import emptyShow from '@/components/empty_view'
export default {
  name: 'circleChart',
  props: ['data', 'title', 'centerTitle', 'performType'],
  components: {
    emptyShow
  },
  data () {
    return {
      emptyImg: emptyImg
    }
  },
  computed: {
    hasData () {
      return (this.data && this.data.kinds && this.data.kinds.length > 0)
    }
  },
  watch: {
    data () {
      console.log('变化了')
      this.initEcharts()
    }
  },
  methods: {
    initEcharts () {
      console.log('传递过来数据：', this.data)
      var circleChart = echarts.init(this.$refs.myCharts)
      circleChart.clear()
      const option1 = {
        title: {
          text: this.performType.toString() === '0' ? '总数' : '',
          subtext: this.performType.toString() === '0' ? this.data.total : '',
          textStyle: {
            fontSize: 20,
            color: '#999',
            lineHeight: 20
          },
          subtextStyle: {
            fontSize: 18,
            color: '#333'
          },
          textAlign: 'center',
          left: '49.7%',
          top: '52%'
        },
        tooltip: {
          trigger: 'item',
          formatter: this.performType.toString() === '0' ? '{a} <br/>{b}: {c} ({d}%)' : '{a} <br/>{b}: {c}'
        },
        legend: {
          orient: 'vertical', // 排列方式
          icon: 'circle', // 图标样式
          right: 10, // 右偏移方式
          top: 'middle', // Y轴偏移方式
          data: this.data.kinds// ['三级', '二级', '一级', '其他'] // 跟Data数据对应
        },
        series: [
          {
            name: this.title,
            type: 'pie',
            radius: ['40%', '60%'],
            avoidLabelOverlap: false,
            top: 60,
            label: {
              show: true,
              position: 'outer',
              formatter: this.performType.toString() === '0' ? '{b|{b}：}{c}  {per|{d}%}' : '{b|{b}：}{c} ',
              backgroundColor: '#eee',
              borderColor: '#aaa',
              borderWidth: 1,
              borderRadius: 4,
              // echarts3饼图不支持IE阴影，去除掉
              // shadowBlur: 3,
              // shadowOffsetX: 2,
              // shadowOffsetY: 2,
              // shadowColor: '#999',
              padding: [0, 0, 0, 7],
              rich: {
                a: {
                  color: '#999',
                  lineHeight: 22,
                  align: 'center'
                },
                b: {
                  fontSize: 16,
                  lineHeight: 33
                },
                per: {
                  color: '#eee',
                  backgroundColor: '#334455',
                  padding: [2, 4],
                  borderRadius: 2
                }
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '30',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: true
            },
            data: this.data.data
          //  [
          //   { value: 335, name: '三级' },
          //   { value: 310, name: '二级' },
          //   { value: 135, name: '一级' },
          //   { value: 1548, name: '其他' }
          // ]
          }
        ]
      }

      circleChart.setOption(option1, true)
    }
  },
  mounted () {
    this.initEcharts()
  }
}
</script>

<style lang="less" scoped>
.pageContent{
  position: relative;
  width: 100%;
  height: 100%;
   .function{
      position: absolute;
      right: 10px;
      top: 20px;
      font-size: 20px;
    }
}
</style>
